import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const OrgDashboardCheckoutCartPageLoadable = clientOnlyLazy({
  loader: () => import('./OrgDashboardCheckoutCartPage.dynamic'),
});
